import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Children, cloneElement, useEffect, useState } from "react";
import { Form } from "react-final-form";
import _ from "lodash";
import { DebugFiltroConsole, DebugFiltroConsultaVisita } from "routes/private/LaudoVisita/functions"

function getFieldAutocompleteOptions(field, data) {
    if (!data) {
        return [];
    }

    let options = data.map((item) => _.get(item, field.props.name) ?? "");
    options.sort();

    return [...new Set(options)];
}

export default function DataFilter({ filters = {}, setFilters, autocompleteOptions, children }) {
    const [fields, setFields] = useState({});

    useEffect(() => {
        const newFields = {};

        for (const child of children) {
            newFields[child.props.name] = {
                required: Boolean(child.props.required),
                databaseFilter: Boolean(child.props.databaseFilter),
                customFilter: child.props.customFilter,
                doFilter: child.props.doFilter,
            };
        }

        setFields(newFields);
    }, [children]);

    function handleSubmit(values, form) {
        let filters = {};

        // Preserva os caracteres "." no nome dos campos,
        // ao invés de usar 'values' que converte em uma árvore de objetos.
        for (const field of form.getRegisteredFields()) {
            const value = form.getFieldState(field).value;

            if (value) {
                filters[field] = {
                    value: value,
                    databaseFilter: fields[field].databaseFilter,
                    doFilter: fields[field].doFilter,
                };
            }
        }

        setFilters(filters);
    }

    function validate(values) {
        const errors = {};

        for (const field in fields) {
            if (fields[field].required && _.isEmpty(_.get(values, field))) {
                _.set(errors, field, "Obrigatório");
            }
        }

        return errors;
    }

    children = Children.toArray(children);

    let requiredFields = [];
    let optionalFields = [];

    for (const child of children) {
        if (child.props.required) {
            requiredFields.push(child);
        } else {
            optionalFields.push(child);
        }
    }

    return (
        <Form
            onSubmit={handleSubmit}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, values, valid }) => (
                <form onSubmit={handleSubmit}>
                    <Box sx={{ m: 2 }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="h6">Filtros</Typography>

                            <DebugFiltroConsole values={values} />
                            <DebugFiltroConsultaVisita form={form} values={values} />

                            <Button color="primary" size="small" onClick={handleSubmit}>
                                Filtrar
                            </Button>
                        </Box>

                        {requiredFields.map((child) => {
                            return cloneElement(child, {
                                autocompleteOptions: getFieldAutocompleteOptions(child, autocompleteOptions),
                            });
                        })}

                        <Accordion sx={{ mt: 2 }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography color="text.secondary">Mais filtros</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {optionalFields.map((child) => {
                                    return cloneElement(child, {
                                        autocompleteOptions: getFieldAutocompleteOptions(child, autocompleteOptions),
                                    });
                                })}
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                </form>
            )}
        />
    );
}
